<template>
  <a-modal
    title="修改密码"
    :width="500"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel"
    class="add-profit"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="新密码" prop="newPwd">
          <a-input
            v-model="form.newPwd"
            type="password"
            placeholder="请输入新密码"
          />
        </a-form-model-item>
        <a-form-model-item label="再次输入新密码" prop="secpassword">
          <a-input
            v-model="form.secpassword"
            type="password"
            placeholder="请再次输入新密码"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Base } from "@/api";
export default {
  components: {},
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPwd) {
        callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      confirmLoading: false,
      visible: false,
      formData: {
        newPwd: "",
        secpassword: "",
      },
      form: {},
      rules: {
        newPwd: [
          {
            required: true,
            message: "请输入新密码!",
            trigger: "change",
          },
        ],
        secpassword: [
          { required: true, message: "请再次输入新密码!", trigger: "change" },
          { validator: validatePass2, trigger: "change" },
        ],
      },
    };
  },
  mounted() {},
  created() {
    this.form = JSON.parse(JSON.stringify(this.formData));
  },
  methods: {
    open(data) {
      this.visible = true;
      if (data) {
        this.form.userCode = data.userCode;
      }
    },
    handleSubmit() {
      let that = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newD = JSON.parse(JSON.stringify(that.form));
          delete newD.secpassword;
          that.save(newD);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save(data) {
      this.confirmLoading = true;
      Base.changePwd(data).then(res => {
        if (res.code == 200) {
          this.pubMsg.tipMessage("修改成功！", "success");
          this.handleCancel(1);
        } else {
          this.pubMsg.tipError(res.msg);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
<style lang="less" scoped></style>
